/**
 * Opens the single System Options tab through the tab provider. The fixed
 * `instanceKey` is the tab's identity, so a second open focuses the existing tab
 * instead of adding another (D-004: a tab, never a dialog).
 */
import type { MenuItem } from '@/types';
import type { OpenTab } from '../DocumentTypes/openDesigner';

export const SYSTEM_OPTIONS_ITEM: MenuItem = {
  id: 'system-options',
  label: 'System Options',
  icon: 'settings',
  type: 'config',
  componentKey: 'SystemOptions',
  order: 0,
};

export const SYSTEM_OPTIONS_INSTANCE_KEY = 'system-options';

export function openSystemOptionsTab(openTab: OpenTab): void {
  openTab(SYSTEM_OPTIONS_ITEM, { instanceKey: SYSTEM_OPTIONS_INSTANCE_KEY, label: 'System Options' });
}
